import MenuItem from "./MenuItem";
import quota from "../../images/profile/profile_quotas.svg"
import association from "../../images/profile/profile_association.svg"
import user from "../../images/user.svg"
import { ProfileMenu } from "../../utils/ProfileMenu"
import "./AreaCard.css";

export default function AreaCard({ onClick }) {

    const clickMyData = () => {
        onClick(ProfileMenu.MY_DATA);
    }

    return (
        <div className="area-card">
            <div className="menu-item-container">
                <MenuItem
                    title="Os meus dados"
                    onClick={clickMyData}
                    icon={<img size={22} src={user} />}
                />

                {/*
                   Bug 266751: Alinhar comportamentos Dashboard / Perfil 
                */}

                {/* <MenuItem
                    title="Quotas"
                    icon={<img size={22} src={quota} />}
                />

                <MenuItem
                    title="Solidariedade Associativa"
                    icon={<img size={22} src={association} />}
                /> */}
            </div>

        </div>
    );
}